import {Typography} from "@mui/material";

export const WorkQueueFoldersInfoContent = (selectorContractGridAPI) => {


    switch(selectorContractGridAPI) {

        case 'Dashboard':
            return {
                title: 'Returned Data Points',
                content: 'Select the Data Points that you want to see on the Dashboard.  ' +
                    'Choose the order in which they will display.'
            };

        default:

            return {
                title: 'Folders',
                content: (
                    <>
                        <Typography paragraph>
                            Folders are the primary method used to organize
                            Contract Data Points within a Contract.
                        </Typography>

                        <ul>
                            <li>
                                Folders are technically Contract Sections, but
                                are referred to as <strong>Folders</strong> in
                                the context of Individual Contract Models.
                            </li>

                            <li>
                                Every Contract Data Point should be assigned to
                                the Folder that most accurately reflects its
                                purpose and business function.
                            </li>

                            <li>
                                Many Folders are processed differently by the
                                system and have special significance during
                                calculations, reporting, and administration.
                            </li>

                            <li>
                                Assigning a Contract Data Point to the wrong
                                Folder can affect how it is displayed, interpreted,
                                or used during calculations.
                            </li>

                            <li>
                                Consistent Folder assignment helps keep Contract
                                Models organized, understandable, and easier to
                                maintain.
                            </li>

                            <li>
                                Hover over a Folder name to view its Description
                                and learn how that Folder is intended to be used.
                            </li>

                            <li>
                                Click on a Folder name to filter the Contract Data
                                Point grid by that Folder, or click
                                on <strong>All Folders</strong> to remove the filtering.
                            </li>

                            <li>
                                Expand a Folder to view the calculation versions
                                generated by the system for that Folder.
                            </li>
                        </ul>
                    </>
                )
            };

    }

};









